import { getSettingsForAccount } from "./api.js";
/**
 * Fetch settings for every paired account and write them into the local cache.
 * Does not change the active account. Failures are logged and skipped.
 */
export async function warmSettingsCache(options) {
    const accounts = await options.storage.listAccounts();
    for (const account of accounts) {
        try {
            const settings = await getSettingsForAccount(options.storage, account);
            await options.settingsCache.save(account, settings);
        }
        catch (error) {
            console.debug("Email Apps settings warm-up failed:", account, error);
        }
    }
}
